import React from 'react'

import { Box, Checkbox, FormControlLabel, Grid, Typography, TextField } from '@material-ui/core'

function ViewBusinessForm2() {
 

  
  const inputValues = [
    //    { label: '', value: profilePicture, name: 'profilePicture' },
    { label: 'Language ', value: 'dummy' },
    { label: 'Currency ', value: 'dummy' },
    { label: 'TimeZone ', value: 'dummy' },
    { label: 'FinancialYear ', value: 'dummy' },
    { label: 'Working Days ', value: 'dummy' },
    { label: 'Reporting Time ', value: 'dummy' },
    { label: 'Releaving Time ', value: 'dummy' },
    { label: 'Holiday ', value: 'dummy' },
  ]
 

  return (
      <Grid lg={12} container>
     
     
        {inputValues.map((item, index) => (
          <Grid item lg={4} style={{padding:'25px'}}>
            <Typography>{item.label}</Typography>
            <Typography>{item.value}</Typography>
          </Grid>
        ))}
      
    </Grid>
  )
}

export default ViewBusinessForm2
